var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',{staticClass:"mfs-auto"},[_c('span',{staticClass:"mr-1",attrs:{"target":"_blank"}},[_vm._v("Copyright")]),_c('span',{attrs:{"ml-3":""}},[_vm._v("GreenLightPlanet Admin Built by PaddyCover")])])])}
var staticRenderFns = []

export { render, staticRenderFns }